// TODO:
// (1)  Propagate the use of these central constants throughout the codebase.
// (2)  Proposal to shift the naming convention to Segments suggested
//      "Object-Action" framework.
//      https://segment.com/academy/collecting-data/naming-conventions-for-clean-data/
import { canNormalizePhone, normalizePhone } from "@penfold/validations/phone";
import pick from "lodash.pick";
import type { User } from "../apollo/prisma1";

export const schema = {
  // Front-end legacy
  // These legacy events do not follow the recommended Segment event object-action pattern.
  USER_CREATED_ACCOUNT: "User Created Account",
  UPDATED_IDENTITY_INFO: "Updated Identify Info",
  ENTERED_IDENTITY_INFO: "Entered Identify Info",

  // Front-end
  SESSION_STARTED_UI: "Session Started UI",

  ACCOUNT_ACTIVATED_UI: "Account Activated UI",
  ONBOARDING_NAME_COMPLETED: "Onboarding Name Step Completed",
  ONBOARDING_NATIONALITY_COMPLETED: "Onboarding Nationality Step Completed",
  ONBOARDING_DOB_COMPLETED: "Onboarding Dob Step Completed",
  ONBOARDING_PHONE_COMPLETED: "Onboarding Phone Step Completed",
  ONBOARDING_ADDRESS_COMPLETED: "Onboarding Address Step Completed",
  ONBOARDING_REFERRAL_COMPLETED: "Onboarding Referral Step Completed",
  ONBOARDING_COMPLETED: "Onboarding Completed",
  FUND_GROUP_SELECTED: "Fund Group Selected",
  FUND_CAROUSEL_MOVED: "Fund Carousel Moved",
  FUND_MORE_DETAILS: "Fund See More Selected",
  FUND_SELECTED: "Fund Selected",
  ACTIVE_FUND_SET: "Active Fund Set",
  ACTIVE_FUND_CHANGED: "Active Fund Changed",

  LEGAL_INTRO_COMPLETED_UI: "Legal Intro Completed UI",
  LEGAL_TAX_INFO_COMPLETED_UI: "Legal Tax Info Completed UI",
  LEGAL_CITIZENSHIP_COMPLETED_UI: "Legal Citizenship Completed UI",
  LEGAL_GENDER_COMPLETED_UI: "Legal Gender Completed UI",
  LEGAL_INFO_SUBMITTED_UI: "Legal Info Submitted UI",
  LEGAL_INFO_SUBMIT_COMPLETED_UI: "Legal Info Submit Completed UI",
  LEGAL_INFO_SUBMIT_ERROR_UI: "Legal Info Submit Error UI",

  MONEY_PATH_SELECTED: "Money Path Selected",
  MONEY_ACCOUNT_TYPE_SELECTED: "Money Account Type Selected",
  MONEY_PAYMENT_FREQUENCY_SELECTED: "Money Payment Frequency Selected",
  MONEY_CONTRIBUTION_AMOUNT_COMPLETED: "Money Contribution Amount Completed",
  MONEY_REGULAR_CONTRIBUTION_CANCELLED_UI:
    "Money Regular Contribution Cancelled UI",
  MONEY_PAYMENT_METHOD_SELECTED: "Money Payment Method Selected",
  MONEY_PAYMENT_DAY_SELECTED: "Money Payment Day Selected",
  MONEY_INSTANT_PAYMENT_BANK_SELECTED_UI:
    "Money Instant Payment Bank Selected UI",
  MONEY_INSTANT_PAYMENT_OPEN_BANKING_INITIATED_UI:
    "Money Instant Payment Open Banking Initiated UI",
  MONEY_BANK_DETAILS_COMPLETED: "Money Bank Details Completed",
  MONEY_BANK_TRANSFER_COMPLETED: "Money Bank Transfer Completed",
  MONEY_SUBMITTED: "Money Submit Submitted",
  MONEY_SUBMIT_COMPLETED: "Money Submit Completed",
  MONEY_UPDATE_COMPLETED: "Money Update Completed",
  MONEY_SUBMIT_ERROR: "Money Submit Error",
  MONEY_EDIT_CANCEL_UI: "Money Edit Cancel UI",

  TOP_UP_ACCOUNT_TYPE_SELECTED_UI: "Top-up Account Type Selected UI",
  TOP_UP_CONTRIBUTION_AMOUNT_COMPLETED_UI:
    "Top-up Contribution Amount Completed UI",
  TOP_UP_PAYMENT_METHOD_SELECTED_UI: "Top-up Payment Method Selected UI",
  TOP_UP_INSTANT_PAYMENT_BANK_SELECTED_UI:
    "Top-up Instant Payment Bank Selected UI",
  TOP_UP_INSTANT_PAYMENT_OPEN_BANKING_INITIATED_UI:
    "Top-up Instant Payment Open Banking Initiated UI",
  TOP_UP_INSTANT_PAYMENT_PAYMENT_SUCCESS_UI:
    "Top-up Instant Payment Payment Success UI",
  TOP_UP_INSTANT_PAYMENT_PAYMENT_PROCESSING_UI:
    "Top-up Instant Payment Payment Processing UI",
  TOP_UP_INSTANT_PAYMENT_PAYMENT_FAILED_UI: "Top-up Instant Payment Failed UI",
  TOP_UP_INSTANT_PAYMENT_PAYMENT_REJECTED_UI:
    "Top-up Instant Payment Rejected UI",
  TOP_UP_BANK_DETAILS_COMPLETED_UI: "Top-up Bank Details Completed UI",
  TOP_UP_BANK_TRANSFER_SUBMITTED_UI: "Top-up Bank Transfer Submitted UI",
  TOP_UP_BANK_TRANSFER_COMPLETED_UI: "Top-up Bank Transfer Completed UI",
  TOP_UP_SUBMITTED_UI: "Top-up Submitted UI",
  TOP_UP_SUBMIT_COMPLETED_UI: "Top-up Submit Completed UI",
  TOP_UP_SUBMIT_ERROR_UI: "Top-up Submit Error UI",

  BENEFICIARIES_FLOW_STARTED_UI: "Beneficiaries flow started UI",
  BENEFICIARIES_DETAILS_SAVED_UI: "Beneficiaries details saved UI",
  BENEFICIARIES_DETAILS_DISCARDED_UI: "Beneficiaries details discarded UI",

  DASHBOARD_CARD_SELECTED_UI: "Dashboard Card Selected UI",
  MOBILE_TAB_SELECTED_UI: "Mobile Tab Selected UI",
  SIDEBAR_TAB_SELECTED_UI: "Sidebar Tab Selected UI",
  SIDEBAR_NAV_ITEM_SELECTED_UI: "Sidebar Nav Item Selected UI",
  MENU_NAV_ITEM_SELECTED_UI: "Menu Nav Item Selected UI",
  MENU_OPENED_UI: "Menu Opened UI",

  ANDROID_STORE_OPENED_UI: "Android Store Opened UI",
  APPLE_STORE_OPENED_UI: "Apple Store Opened UI",
  APP_STORE_REVIEW_REQUESTED: "App Store Review Requested",
  USER_DEMONSTRATED_ENGAGEMENT: "User Demonstrated Engagement",

  EXPLORE_PENSION_REDIRECT_UI: "Explore Pension Redirect UI",

  // Back-end
  ADDRESS_LOOKUP_FAILED: "Address look up failed",
  ADDRESS_LOOKUP_TOO_MANY: "Address look up return more than one",
  ACCOUNT_ACTIVATION_CONFIRMED: "Account Activation Confirmed",
  AML_FAILED: "AML Failed",
  AML_PASSED: "AML Passed",
  BANK_ACCOUNT_UPDATED: "Bank Account Updated",
  IDENTITY_DETAILS_UPDATED: "Identity details updated",
  BANK_TRANSFER_CONFIRMED: "Bank Transfer Confirmed",
  DIRECT_DEBIT_MANDATE_CREATED: "Direct Debit Mandate Created",
  FUND_SET_CONFIRMED: "Fund Set Confirmed",
  LIFESTYLE_FUND_SET_CONFIRMED: "Lifestyle Fund Set Confirmed",
  FUND_CHANGE_CONFIRMED: "Fund Change Confirmed",
  LIFESTYLE_FUND_CHANGE_CONFIRMED: "Lifestyle Fund Change Confirmed",
  REGULAR_CONTRIBUTION_CREATED: "Regular Contribution Created",
  REGULAR_CONTRIBUTION_PAUSED: "Regular Contribution Paused",
  REGULAR_CONTRIBUTION_RESUMED: "Regular Contribution Resumed",
  REGULAR_CONTRIBUTION_UPDATED: "Regular Contribution Updated",
  REGULAR_CONTRIBUTION_CANCELLED: "Regular Contribution Cancelled",
  REGULAR_CONTRIBUTION_RECEIVED: "Regular Contribution Received",
  TRANSFER_CREATED: "Transfer Created",
  TRANSFER_REQUESTED: "Transfer Requested",
  WORKPLACE_INVITATION: "Workplace Invitation",

  DIRECT_DEBIT_ONE_OFF_CREATED: "Direct Debit One Off Created",
  BANK_TRANSFER_ONE_OFF_CREATED: "Bank Transfer One Off Created",
  INSTANT_PAYMENT_ONE_OFF_CREATED: "Instant Payment One Off Created",

  // App
  APP_OPENED_BY_PUSH_NOTIFICATION: "App opened by push notification",
  APP_OPENED_BY_URL: "App opened by URL",
} as const;

export type AnalyticsEvent = typeof schema[keyof typeof schema];

export const userDataWhitelist: ReadonlyArray<keyof User> = [
  "email",
  "id",
  "dateOfBirth",
  "expectedFirstPaymentDate",
  "firstName",
  "lastName",
  "milestone",
  "monthlyContribution",
  "paymentDay",
  "referralId",
  "referredBy",
  "secclAccountId",
  "title",
  "phone",
  "isStarling",
  "isWorkplace",
] as const;

export const additionalDataWhitelist = [
  "fund",
  "state",
  "amlReviewRequired",
] as const;

export const paymentDataWhitelist = [
  "bankAccount.accountType", // TODO. Deprecate after money wizard launch
  "activationPath",
  "accountType",
  "frequency",
  "paymentMethod",
  "mandateAccepted",
  "companyName",
  "companyNumber",
  "contribution",
  "amount",
] as const;

const sensitiveDataWhitelist = [
  ...userDataWhitelist,
  ...additionalDataWhitelist,
  ...paymentDataWhitelist,
];

const formatters = {
  phone: (val) => {
    if (canNormalizePhone(val)) {
      // NOTE: We believe vero requires this format
      return normalizePhone(val).replace("+", "");
    }
  },
};

export const formatData = (user) => {
  for (const f in formatters) {
    if (user[f]) {
      user[f] = formatters[f](user[f]);
    }
  }
  return user;
};

export const removeSensitiveEventData = (data: any) =>
  formatData(pick(data, sensitiveDataWhitelist));

export const removeSensitiveUserData = (user: Partial<User>) =>
  formatData(pick(user, userDataWhitelist));

export type AppOpenEventData = {
  path: string;
  appColdStart: boolean;
};
